import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle
} from "reactstrap";

const CardProjecao = ({ title, color, dados }) => {

  return(
    <Card className="card-pricing" style={{backgroundColor: color}}>
      <CardHeader>
        <CardTitle tag="h3">{title}</CardTitle>
      </CardHeader>
      <CardBody>
        <h6 className="card-category">Vendas realizadas ate o momento</h6>
        <h5>{dados.momento ? parseFloat(dados.momento).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }) : 'R$ 00,00'}</h5>
        <h6 className="">Lucro {parseFloat(dados.momento - dados.momentoCMV).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}</h6>
        <hr/>

        <h6 className="card-category">Vendas realizadas no ano anterior</h6>
        <h5>{dados.anteriorDiaHora ? parseFloat(dados.anteriorDiaHora).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }) : 'R$ 00,00'}</h5>
        <h6 className="">Lucro {parseFloat(dados.anteriorDiaHora - dados.anteriorDiaHoraCMV).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}</h6>
        <hr/>

        <h6 className="card-category">Variação</h6>
        <h5>{dados.variacao ? dados.variacao+' %' : '00,00 %'}</h5>
        <hr/>

        <h6 className="card-category">Projeção</h6>
        <h5>{dados.projecao ? parseFloat(dados.projecao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }) : 'R$ 00,00'}</h5>
      </CardBody>
    </Card>
  )
}



export default CardProjecao
